import { Component } from "react";
import { connect } from "react-redux";
import { transformToSPP, deleteArOrPps } from "../../../redux/analyseRisques/analyseRisquesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";
import { MODULE_PPS } from "../../../redux/authorizedApps/authorizedAppsConstants";
import { haveModuleAuthorization } from "../../../redux/authorizedApps/authorizedAppsActions";

class ValidatedAnalyseRisques extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ppsAuthorization: false,
        };

        props.haveModuleAuthorization(MODULE_PPS, props.activeUser).then((haveModuleAuthorization) => {
            this.setState({
                ppsAuthorization: haveModuleAuthorization,
            });
        });
    }

    transformToSPP() {
        this.props.transformToSPP(this.props.analyseRisques, this.props.activeUser.id);
    }

    deleteArOrPps() {
        this.props.deleteArOrPps(this.props.analyseRisques, this.props.activeUser, this.props.analysesRisques);
    }

    render() {
        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                        <Fab onClick={this.deleteArOrPps.bind(this)} className="red-button div-center">
                            <Icon>delete</Icon>
                        </Fab>
                        <span className="floating-btn-text span-center">Supprimer</span>
                    </div>
                    {this.state.ppsAuthorization ? (
                        <div className="offset-lg-8 col-lg-2 offset-md-8 col-md-2 offset-sm-4 col-sm-4 offset-4 col-4 center">
                            <div className="center">
                                <Fab onClick={this.transformToSPP.bind(this)} color="primary" className="div-center">
                                    <Icon>transform</Icon>
                                </Fab>
                                <span className="floating-btn-text span-center">Transformer en Plan de prévention</span>
                            </div>
                        </div>
                    ) : null}
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        analyseRisques: state.analyseRisques,
        analysesRisques: state.analysesRisques,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        transformToSPP: (analyseRisques, userId) => dispatch(transformToSPP(analyseRisques, userId)),
        deleteArOrPps: (analyseRisques, activeUser, analysesRisquesState) =>
            dispatch(deleteArOrPps(analyseRisques, activeUser, analysesRisquesState)),
        haveModuleAuthorization: (moduleName, user) => dispatch(haveModuleAuthorization(moduleName, user)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ValidatedAnalyseRisques);
